<template>
    <div>
        <div class="title">Attach Files</div>
        <b-card>
            <b-row>
                <b-col cols="12">
                    <vue-dropzone
                        :disabled="readonly"
                        :class="{
                            'none-remove': readonly,
                            upfile: maxFiles,
                        }"
                        ref="myVueDropzone"
                        id="dropzone"
                        @vdropzone-error="vdropzoneError"
                        v-on:vdropzone-remove="removeFile"
                        @vdropzone-max-files-reached="onMaxFiles"
                        @vdropzone-removed-file="onRemoveFiles"
                        @vdropzone-success="onAddFile"
                        @vdropzone-max-files-exceeded="onMaxFiles"
                        :options="dropzoneOptions"
                        :destroy-dropzone="false"
                        :useCustomSlot="true"
                    >
                        <div v-show="true" class="custom_file">
                            <span class="ml-10" v-show="totalFiles < 20">
                                <div class="color-gray">
                                    Please upload booking and other document related to this shipment here.
                                </div>
                               
                            </span>
                            <b-img
                                width="65px"
                                class="mr-10"
                                :src="iconUpload"
                                alt="logo"
                            />
                        </div>
                    </vue-dropzone>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { $ctx } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { BFormGroup, BRow, BCol, BCard } from "bootstrap-vue";
export default {
    props: {
        quotationInfo: { default: null },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        BFormGroup,
        BRow,
        BCol,
        BCard,
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            iconUpload: require("@/assets/images/icons/iconUpload.png"),
            userData: JSON.parse(localStorage.getItem("userData")),

            dropzoneOptions: {
                url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
                addRemoveLinks: !this.readonly,
                acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
                maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
                maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
                headers: { apiKey: localStorage.getItem("accessToken") },
                clickable: !this.readonly,
            },
            totalFiles: 0,
            maxFiles: false,
            quotationInfoTemp: {},
        };
    },
    mounted() {
        if (this.quotationInfo && this.quotationInfo?.files) {
            this.quotationInfo.files.map((e) => {
                if (e) {
                    this.$refs.myVueDropzone.manuallyAddFile(
                        e,
                        e.download_path
                    );
                    this.maxFiles = true;
                    this.totalFiles++;
                }
            });
        } else {
            this.quotationInfoTemp = { files: [] };
        }
    },
    methods: {
        removeFile(file, error, xhr) {
            if (file && file.xhr !== undefined) {
                const xhrJson = JSON.parse(file.xhr.response);
                const path = xhrJson.result.path;
                const bookingId = "-1";
                this.$store.dispatch("attachFile/deleteFile", {
                    bookingId,
                    path,
                });
            }
        },
        onAddFile(file) {
            if (file.status == "success") {
                this.totalFiles == 5
                    ? (this.totalFiles = 5)
                    : this.totalFiles++;
                this.maxFiles = true;
                if (this.quotationInfo) {
                    for (
                        var i = 0;
                        i < this.$refs.myVueDropzone.getAcceptedFiles().length;
                        i++
                    ) {
                        var file = JSON.parse(
                            this.$refs.myVueDropzone.getAcceptedFiles()[i].xhr
                                .response
                        ).result;
                        file.size =
                            this.$refs.myVueDropzone.getAcceptedFiles()[i].size;
                        file.date = moment(new Date()).format(
                            "DD/MM/YYYY HH:mm:ss"
                        );
                        file.uuid =
                            this.$refs.myVueDropzone.getAcceptedFiles()[
                                i
                            ].upload.uuid;
                        file.fullName = this.userData.fullName;
                        file.username = this.userData.username;
                        const checkPushItem = this.quotationInfo.files.filter(
                            (e) => e.uuid == file.uuid
                        );
                        if (checkPushItem.length == 0) {
                            this.quotationInfo.files.push(file);
                            if (
                                this.quotationInfo.files.length ==
                                this.$Utils.CONSTANTS.TYPE_UPLOAD.max
                            ) {
                                this.maxFiles = false;
                            }
                        }
                    }
                } else {
                    for (
                        var i = 0;
                        i < this.$refs.myVueDropzone.getAcceptedFiles().length;
                        i++
                    ) {
                        if (
                            !!this.$refs.myVueDropzone.getAcceptedFiles()[i]
                                ?.xhr?.response
                        ) {
                            var file = JSON.parse(
                                this.$refs.myVueDropzone.getAcceptedFiles()[i]
                                    .xhr.response
                            ).result;
                            file.size =
                                this.$refs.myVueDropzone.getAcceptedFiles()[
                                    i
                                ].size;
                            file.date = moment(new Date()).format(
                                "DD/MM/YYYY HH:mm:ss"
                            );
                            file.uuid =
                                this.$refs.myVueDropzone.getAcceptedFiles()[
                                    i
                                ].upload.uuid;
                            file.fullName = this.userData.fullName;
                            file.username = this.userData.username;
                            const checkPushItem =
                                this.quotationInfoTemp.files.filter(
                                    (e) => e.uuid == file.uuid
                                );
                            if (checkPushItem.length == 0) {
                                this.quotationInfoTemp.files.push(file);
                                if (
                                    this.quotationInfoTemp.files.length ==
                                    this.$Utils.CONSTANTS.TYPE_UPLOAD.max
                                ) {
                                    this.maxFiles = false;
                                }
                            }
                        }
                    }
                }
            }
        },
        vdropzoneError(file, errorMessage) {
            this.$refs.myVueDropzone.removeFile(file);
            if (errorMessage.includes("Max filesize: 10MiB")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadSizeErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }

            if (errorMessage.includes("You can not upload any more files.")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadLimitErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }
        },
        onMaxFiles(file) {
            if (file.length == this.$Utils.CONSTANTS.TYPE_UPLOAD.max) {
                this.maxFiles = false;
            }
        },
        onRemoveFiles(file) {
            if (this.quotationInfo) {
                this.quotationInfo.files = this.quotationInfo.files.filter(
                    (e) => e.uuid !== (file?.upload?.uuid || file.uuid)
                );
                this.totalFiles = this.quotationInfo.files.length;
                if (this.totalFiles == 0) this.maxFiles = false;
                else this.maxFiles = true;
            } else {
                this.quotationInfoTemp.files =
                    this.quotationInfoTemp.files.filter(
                        (e) => e.uuid !== (file?.upload?.uuid || file.uuid)
                    );
                this.totalFiles = this.quotationInfoTemp.files.length;
                if (this.totalFiles == 0) this.maxFiles = false;
                else this.maxFiles = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.color-gray{
    color:#C9C9D1
}
.mr-10 {
    margin-right: 100px;
}
.ml-10 {
    text-align: left;
    margin-left: 20px;
}
.vue-dropzone {
    border: none !important;
}
.card-body {
    padding: 0 !important;
}
.custom_file {
    display: flex;
    justify-content: space-between;
}
.upfile .dz-message {
    display: block !important;
    margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    .click-here {
        display: block !important;
        justify-content: start;
        align-self: self-start;
        align-items: start;
    }
    .upload {
        display: none !important;
    }
}
.dropzone .dz-message {
    text-align: start;
}
.btn-upload {
    padding: 0.286rem 1rem;
}
</style>
